<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'IMOCrewList',
};
</script>

<style scoped>

</style>
